import { createSlice } from '@reduxjs/toolkit'
import { languages } from '../../../../../../configs/language'
import { keyBy } from '../../../../../helpers/common'
import { register } from '../../../../../helpers/reducerRegistry'
import { UNIT } from '../../../../../utils/currency'
import { mapCurrency } from '../constants'
import { getLastPurchaseDate } from './thunk'

const slice = createSlice({
  name: 'common/order/popupConfirmationBuyNowOrAddCart',
  initialState: {
    ids: [],
    data: {},
    isAddCart: false,
    isFactSheet: false,
    reportName: undefined,
    reportId: undefined,
    lastPurchaseDate: undefined,
    isFromLibrary: false,
  },
  reducers: {
    changeItem: (state, { payload = {} }) => {
      state.data[payload.id] = {
        ...state.data[payload.id],
        ...payload.data,
      }
    },
    changeData: (state, { payload = {} }) => {
      const {
        isAddCart,
        isFactSheet,
        data,
        reportName,
        currencyCode = mapCurrency.VND.value,
        currencyUnit = UNIT.SINGLE.multiplier,
        isFromLibrary,
      } = payload

      state.isAddCart = isAddCart
      state.isFactSheet = isFactSheet
      state.reportName = reportName
      state.isFromLibrary = isFromLibrary
      state.reportId = data.length ? data[0].fiinGateReportTypeId : undefined

      const dataWithId = data.map((item, index) => {
        let result = {
          ...item,
          id: index,
          currencyCode,
        }

        if (isFactSheet) {
          result = {
            ...result,
            currencyUnit,
          }
        } else {
          result = {
            ...result,
            languageCode: languages.en,
          }
        }

        return result
      })
      state.ids = dataWithId.map((item) => item.id)
      state.data = keyBy(dataWithId, 'id')
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getLastPurchaseDate.fulfilled,
      (state, { payload = [] }) => {
        const [data = {}] = payload
        state.lastPurchaseDate = data.lastPurchaseDate
      },
    )
  },
})

export const selectIds = (state) => state[slice.name].ids
export const getDataFromRedux = (rowId, colId) => (state) =>
  state[slice.name].data[rowId][colId]
export const selectData = (state) => state[slice.name].data
export const selectIsAddCart = (state) => state[slice.name].isAddCart
export const selectIsFactSheet = (state) => state[slice.name].isFactSheet
export const selectReportName = (state) => state[slice.name].reportName
export const selectIsFromLibrary = (state) => state[slice.name].isFromLibrary
export const selectReportId = (state) => state[slice.name].reportId
export const selectLastPurchaseDate = (state) =>
  state[slice.name].lastPurchaseDate

export const { changeItem, changeData } = slice.actions

register(slice.name, slice.reducer)
